<script setup lang="ts">
import CommunicationSwitch from "@/communication/components/toolbar/CommunicationSwitch.vue";
import {Gift, History, ChevronRight} from "@lucide/vue";
import Icon from "@/core/components/icon/Icon.vue";
import BuyCreditsButton from "@/communication/components/buttons/BuyCreditsButton.vue";

defineProps<{
    loading: boolean;
    creditBalance: number;
}>();

const mode = defineModel<'notification' | 'sms'>('mode');
</script>

<template>
  <div class="flex pt-2 items-centers justify-between flex-wrap gap-4">
    <CommunicationSwitch v-model:mode="mode" :loading="loading" class="self-center" />
    <div class="flex items-center gap-4 ml-auto">
      <div
        v-if="mode === 'notification'"
        class="flex bg-secondary-dark/20 text-secondary-darkest rounded-full px-4 py-2 gap-2 items-center"
      >
        <Gift class="size-5 text-secondary-darkest" />
        <span class="font-medium leading-tight">Envoi gratuit : notification push</span>
      </div>
      <div v-if="mode === 'sms'" class="flex items-center gap-4">
        <div class="border shadow-sm bg-white rounded-full flex py-1 pl-1 pr-2 leading-tight items-center gap-1">
          <div class="rounded-full border p-1">
            <Icon class="mdi-send" color="primary" :size="16" />
          </div>
          <span class="text-sm font-medium">
            {{ creditBalance }}
            <span class="text-sm font-medium text-muted-foreground">Crédits restants</span>
          </span>
        </div>
        <BuyCreditsButton />
      </div>
      <router-link
        :to="{name: 'patient-administration.communication.conversation-messages', query: {tab: 'batches'}}"
      >
        <div class="flex items-center text-primary group">
          <History class="size-5 mr-1" />
          <span class="leading-tight font-medium group-hover:underline">Historique des envois</span>
          <ChevronRight class="size-4" />
        </div>
      </router-link>
    </div>
  </div>
</template>
